import { getInitialLocale } from "./environment";
import { initializeDigitalData } from "./initializeDigitalData";

/**
 * Synchronously initializes globalThis.digitalData before any React components mount.
 * Ensures ContentRouterWidget and other consumers have digitalData available on first render.
 */
export const initDigitalDataSync = (): void => {
  if (typeof globalThis === "undefined") return;
  if (typeof globalThis.location === "undefined") return;
  if (globalThis.digitalData) return;

  const locale = getInitialLocale();
  globalThis.digitalData = initializeDigitalData(locale);

  try {
    Object.preventExtensions(globalThis.digitalData);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    console.warn(
      "[DDL] Failed to prevent extensions on digitalData object:",
      message
    );
  }
};
